/**
 * RP51-55 — Libellés du circuit VISA (09-VOCABULAIRE §3 : « À viser » → « VSO » /
 * « VAO » / « Refusé » → nouvel indice ; §1 : « Plan (indice B) »).
 * Les clés techniques (a_viser, vso, vao, refuse) ne sont jamais affichées.
 */
export const STATUT_VISA = {
  a_viser: 'À viser',
  vso: 'VSO (visa sans observation)',
  vao: 'VAO (visa avec observations)',
  refuse: 'Refusé',
};

export const STATUT_VISA_COURT = {
  a_viser: 'À viser',
  vso: 'VSO',
  vao: 'VAO',
  refuse: 'Refusé',
};

export const STATUT_VISA_COULEUR = {
  a_viser: 'bg-amber-100 text-amber-800',
  vso: 'bg-emerald-100 text-emerald-800',
  vao: 'bg-sky-100 text-sky-800',
  refuse: 'bg-rose-100 text-rose-800',
};

export const NATURES_PIECE = {
  plan: 'Plan',
  note_calcul: 'Note de calcul',
  fiche_technique: 'Fiche technique',
  cctp: 'CCTP',
  rapport: 'Rapport',
  autre: 'Document',
};

export const DELAI_VISA_JOURS = 15;

export function libellePiece(nature, indice) {
  return `${NATURES_PIECE[nature] || 'Document'} (indice ${indice || 'A'})`;
}

export function libelleDelai(visa) {
  if (!visa || visa.statut !== 'a_viser' || visa.jours_restants == null) return '';
  if (visa.en_retard) {
    const j = Math.abs(visa.jours_restants);
    return `En retard de ${j} jour${j > 1 ? 's' : ''}`;
  }
  if (visa.jours_restants === 0) return "Avis attendu aujourd'hui";
  return `${visa.jours_restants} jour${visa.jours_restants > 1 ? 's' : ''} restant${visa.jours_restants > 1 ? 's' : ''}`;
}

export function dateFr(iso) {
  if (!iso) return '';
  try {
    return new Date(`${String(iso).slice(0, 10)}T00:00:00`).toLocaleDateString('fr-FR');
  } catch {
    return iso;
  }
}
